import { render, staticRenderFns } from "./ForestFire.vue?vue&type=template&id=b635d49c&scoped=true&"
import script from "./ForestFire.vue?vue&type=script&lang=js&"
export * from "./ForestFire.vue?vue&type=script&lang=js&"
import style0 from "./ForestFire.vue?vue&type=style&index=0&id=b635d49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b635d49c",
  null
  
)

export default component.exports